import axios from "axios";
import { toast } from "react-toastify";

import {
    GET_OFFER_OPTIONS,
    ADD_OFFER_OPTION,
    DELETE_OFFER_OPTION,
    GET_OFFER_OPTION,
    UPDATE_OFFER_OPTION
} from "../types";

const basePath = process.env.REACT_APP_API_URL + "/api/offer-option";

export const getOfferOptions = () => async dispatch => {
    try {
        const res = await axios.get(`${basePath}/viewAll`);

        dispatch({
            type: GET_OFFER_OPTIONS,
            payload: res.data
        });

        return res.data.offerOptions;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const addOfferOption = data => async dispatch => {
    const config = {
        headers: {
            "Content-Type": "application/json"
        }
    };

    const body = JSON.stringify(data);

    try {
        const res = await axios.post(`${basePath}/add`, body, config);

        dispatch({
            type: ADD_OFFER_OPTION,
            payload: res.data
        });

        toast.success("Offer Option Created.");

        return true;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const updateOfferOption = (data, id) => async dispatch => {
    const config = {
        headers: {
            "Content-Type": "application/json"
        }
    };

    const body = JSON.stringify(data);

    try {
        const res = await axios.put(`${basePath}/update/${id}`, body, config);

        dispatch({ type: UPDATE_OFFER_OPTION, payload: res.data });

        toast.success("Offer Option Updated.");

        return true;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const getOfferOption = id => async dispatch => {
    try {
        const res = await axios.get(`${basePath}/view/${id}`);

        dispatch({ type: GET_OFFER_OPTION });

        return res.data.offerOption;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const deleteOfferOption = id => async dispatch => {
    try {
        await axios.delete(`${basePath}/delete/${id}`);

        dispatch({
            type: DELETE_OFFER_OPTION,
            payload: id
        });

        toast.success("Offer Option Deleted.");
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};
